import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';

import { Button, Col, Row } from 'antd';
import CustomInputNumber from '../../components/CustomInputNumber/CustomInputNumber';
import { textSort } from '../../helpers/textSort';

const StandardDev = ({t, storedPrimitives, setStoredPrimitives, hendleChangeValue, validate}) => {

  const assets = useSelector((state) => state.instrumentsReducer.assets);

  const [primitivesSet, setPrimitivesSet] = useState(null);

  useEffect(() => {
    if(storedPrimitives) {
      const data = storedPrimitives?.filter( i=> i.entity === 4);
      if(!data?.length) {
        return;
      }
      setPrimitivesSet(data?.sort((a, b) => textSort(getAssetById(a.asset_class_1_id)?.name, getAssetById(b.asset_class_1_id)?.name)));
    }
  }, [storedPrimitives]);

  useEffect(() => {
    if(primitivesSet?.length) {
      validate(primitivesSet.every(i => i.adjustment || i.adjustment === 0), 'standardDev');
    } else {
      validate(false, 'standardDev');
    }
  }, [primitivesSet]);

  const getAssetById = (id) => {
    const asset = assets.find(asset => asset.ID === id);
    return {name: asset?.name ?? '', category: asset?.financialAssetCategory.name ?? ''};
  };

  const handleClearAll = () => {
    const clonData = cloneDeep(storedPrimitives);
    const newData = clonData.map(i => {
      if(i.entity === 4) {
        const el = {...i, adjustment: null};
            return el;
      } else {
          return i;
      }
    });
      setStoredPrimitives(newData);
  };

  return (
    <>
      <Row wrap={false} className="primitives-header">
        <Col
          span={8}
          className="primitives-title-class contrast"
        >
          {t('ASSET_CLASS')}
        </Col>
        <Col span={8} className="primitives-title-value">
          {t('QUANT_VALUE')}
        </Col>
        <Col span={4} className="primitives-title-override">
          {t('OVERRIDE')}
        </Col>
        <Col span={4} className="asset-class-title-allocation">
          <Button
            className="portfolio-details-btn primitives-clear-btn"
            onClick={handleClearAll}>
            {t('CLEAR_ALL')}
          </Button>
        </Col>
      </Row>
      {primitivesSet &&
        primitivesSet?.map((el) => {
          return (
            <Row key={el.asset_class_1_id} wrap={false} className={'primitives-row'}>
              <Col span={8} className="primitives-title-class">
                <div className=''>
                  <p className='primitives-cell-name'>{getAssetById(el.asset_class_1_id)?.name}</p>
                  <p className='primitives-cell-category'>{getAssetById(el.asset_class_1_id)?.category}</p>
                </div>
              </Col>
              <Col span={8} className="primitives-title-value cell">
                <div className=''>{(el?.value * 100).toFixed(2)}</div>
              </Col>
              <Col span={7} className="primitives-title-override cell">
                <div className=''>
                  <CustomInputNumber
                    width={'132px'}
                    percent
                    precision={2}
                    min={0}
                    value={el?.adjustment ? + ((el?.value + el?.adjustment) * 100).toFixed(2) : el?.adjustment === 0 ? 0 : ''}
                    onBlur={(e) => hendleChangeValue(el.id, e.target.value, null, 'value')}
                    className="custom-inputnumber model-series"
                    controls={false}
                  />
                </div>
              </Col>
            </Row>
          );
        }
      )
      }
    </>
  );
};

export default StandardDev;

StandardDev.propTypes = {
  t: PropTypes.func.isRequired,
  storedPrimitives: PropTypes.array,
  setStoredPrimitives: PropTypes.func.isRequired,
  hendleChangeValue: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};